import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Stack } from '@mui/material';

import { Modal } from 'components/Modal';
import { FormProvider, TextField } from 'components/Form';
import useYupValidationResolver from 'hook/useYupValidationResolver';

import { useDeclineQuestion } from '../api/declineQuestion';
import { declineValidationSchema } from '../validation';
import { InfoRow, ModalActions, textAreaSx } from './ModalActions';

export const DeclineQuestionModal = ({ resource, id, question, open, handleClose }) => {
  const methods = useForm({
    defaultValues: { reason: '' },
    resolver: useYupValidationResolver(declineValidationSchema),
  });
  const { mutate: declineQuestion, isPending } = useDeclineQuestion(resource, id, handleClose);

  const { reset, handleSubmit } = methods;
  useEffect(() => {
    if (open) reset({ reason: '' });
  }, [open, reset]);

  const onSubmit = ({ reason }) => declineQuestion({ questionId: question.question_id, reason });

  return (
    <Modal title="Decline question" open={open} handleClose={handleClose} sx={{ width: 560 }}>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <Stack gap={1.5} mb={3}>
          <InfoRow label="Supplier" value={question?.company_name} />
          <InfoRow label="Question" value={question?.question} />
          <TextField
            fullWidth
            name="reason"
            label="Reason"
            helperText="The asking supplier sees this reason"
            multiline
            minRows={3}
            required
            sx={textAreaSx}
          />
        </Stack>
        <ModalActions
          onCancel={handleClose}
          onSubmit={handleSubmit(onSubmit)}
          submitLabel="Decline"
          disabled={isPending}
        />
      </FormProvider>
    </Modal>
  );
};
